import { setDefaultStyle } from "apparatus/draw";
import { P, R, S, Segments } from "apparatus/library/common";
import { CompoundPath, Group, Path, Shape } from "paper";
import { breakPath } from "../draw";
export var Tubes;
(function (Tubes) {
    Tubes.MIN_DIAMETER = 8;
    Tubes.MAX_DIAMETER = 50;
})(Tubes || (Tubes = {}));
const MIN_DIAMETER = Tubes.MIN_DIAMETER;
const MAX_DIAMETER = Tubes.MAX_DIAMETER;
export const TUBE_DIAMETER_SPEC = {
    spec: "slider", key: "diameter", label: "Diameter",
    min: MIN_DIAMETER, max: MAX_DIAMETER
};
let bendSpecs = {
    min: -135, max: 135, step: 5,
    pipsStep: 9, unit: "°"
};
let lengthSpecs = {
    label: "Length", min: 0, max: 300
};
let defaultDiameter = 15;
export class TubeBend {
    render(appearance) {
        let diameter = appearance.diameter;
        let semilength = 25;
        let onesidelength = appearance.length;
        let angle = appearance.angle;
        let { topWall, bottomWall, snapping } = tubeBend(diameter, angle, semilength, onesidelength);
        let graphic = new Group([topWall, bottomWall]);
        setDefaultStyle(graphic);
        let hitShape = new Path([...topWall.segments, ...bottomWall.segments]);
        // let pivot = angle != 0 ? P(semilength, 0).add([rotationPivotDistance * Math.tan(angle.toRadians() / 2), 0]) : P(semilength + tubeBendLength / 2, 0)
        return {
            graphic: graphic,
            hitShape: hitShape,
            snapping: [
                { type: "connectable", at: P(0, 0), facing: -90 },
                snapping,
            ]
        };
    }
}
TubeBend.properties = {
    label: "Tube bend",
    kind: "tube",
    defaultAppearance: {
        angle: -75,
        diameter: defaultDiameter,
        length: 25
    },
    appearanceSpecs: [
        Object.assign({ spec: "slider", key: "angle", label: "Bend Angle" }, bendSpecs),
        TUBE_DIAMETER_SPEC,
        Object.assign({ spec: "slider", key: "length" }, lengthSpecs),
    ],
};
export class Tube {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 30, maxX: 600,
                minY: 20, maxY: 20,
                fromAppearance: a => P(a.length, 20),
                toAppearance: (f, p) => f({ length: p.x }),
                scale: 2.0,
            }
        ];
    }
    render(appearance) {
        let radius = appearance.diameter / 2;
        let length = appearance.length;
        let topWall = new Path(Segments([[0, -radius]], [[length, -radius]]));
        let bottomWall = new Path(Segments([[0, radius]], [[length, radius]]));
        let graphic = new Group([topWall, bottomWall]);
        setDefaultStyle(graphic);
        var hitShape = Shape.Rectangle(R(0, -radius, length, radius * 2));
        return {
            graphic: graphic,
            hitShape: hitShape,
            snapping: [{
                    type: "connectable", at: P(0, 0), facing: -90,
                }, {
                    type: "connectable", at: P(length, 0), facing: 90,
                }]
        };
    }
}
Tube.properties = {
    label: "Straight tube",
    kind: "tube",
    defaultAppearance: {
        length: 100,
        diameter: defaultDiameter,
    },
    appearanceSpecs: [
        TUBE_DIAMETER_SPEC,
        {
            spec: "slider", key: "length", label: "Length",
            min: 30, max: 600
        },
    ],
};
export class FourWayCrossing {
    render(appearance) {
        let diameter = appearance.diameter;
        let radius = diameter / 2;
        let outer = radius + 20;
        let path = new CompoundPath({});
        path.moveTo(P(radius, -outer));
        path.lineTo(P(radius, -radius));
        path.lineTo(P(outer, -radius));
        path.moveBy(P(0, diameter));
        path.lineTo(P(radius, radius));
        path.lineTo(P(radius, outer));
        path.moveBy(P(-diameter, 0));
        path.lineTo(P(-radius, radius));
        path.lineTo(P(-outer, radius));
        path.moveBy(P(0, -diameter));
        path.lineTo(P(-radius, -radius));
        path.lineTo(P(-radius, -outer));
        setDefaultStyle(path);
        return {
            graphic: path, hitShape: path.bounds.toShape(),
            snapping: [
                { type: "connectable", at: P(0, outer), facing: 180 },
                { type: "connectable", at: P(outer, 0), facing: 90 },
                { type: "connectable", at: P(0, -outer), facing: 0 },
                { type: "connectable", at: P(-outer, 0), facing: -90 },
            ]
        };
    }
}
FourWayCrossing.properties = {
    label: "4-Way Crossing",
    kind: "tube",
    defaultAppearance: {
        diameter: defaultDiameter
    },
    appearanceSpecs: [
        TUBE_DIAMETER_SPEC
    ],
};
export class ThreeWayCrossing {
    render(appearance) {
        let diameter = appearance.diameter;
        let radius = diameter / 2;
        let outer = radius + 20;
        let path = new CompoundPath({});
        path.moveTo(P(radius, -outer));
        path.lineTo(P(radius, -radius));
        path.lineTo(P(outer, -radius));
        path.moveBy(P(0, diameter));
        path.lineTo(P(radius, radius));
        path.lineTo(P(radius, outer));
        path.moveBy(P(-diameter, 0));
        path.lineTo(P(-radius, -outer));
        setDefaultStyle(path);
        return {
            graphic: path, hitShape: path.bounds.toShape(),
            snapping: [
                { type: "connectable", at: P(0, outer), facing: 180 },
                { type: "connectable", at: P(0, -outer), facing: 0 },
                { type: "connectable", at: P(outer, 0), facing: 90 },
            ]
        };
    }
}
ThreeWayCrossing.properties = {
    label: "3-Way Crossing",
    kind: "tube",
    flippable: true,
    defaultAppearance: {
        diameter: defaultDiameter
    },
    appearanceSpecs: [
        TUBE_DIAMETER_SPEC
    ],
};
export class UTube {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 0, maxX: 0,
                minY: 30, maxY: 150,
                fromAppearance: a => P(0, a.size),
                toAppearance: (f, p) => f({ size: p.y }),
                scale: 2.0,
            }
        ];
    }
    render(appearance) {
        let bendRadius = appearance.size;
        let diameter = appearance.diameter;
        let outerRadius = bendRadius + diameter;
        let path = new Path(Segments([[-bendRadius, -50]], [[-bendRadius, 0], undefined, [0, bendRadius * 1.4]], [[bendRadius, 0], [0, bendRadius * 1.4]], [[bendRadius, -50]], [[outerRadius, -50]], [[outerRadius, 0], undefined, [0, outerRadius * 1.4]], [[-outerRadius, 0], [0, outerRadius * 1.4]], [[-outerRadius, -50]]));
        let graphic = breakPath(path, 4);
        setDefaultStyle(graphic);
        return {
            graphic: graphic,
            hitShape: path,
            snapping: [
                { type: "connectable", at: P(-bendRadius - diameter / 2, -50), facing: 0 },
                { type: "connectable", at: P(bendRadius + diameter / 2, -50), facing: 0 },
            ]
        };
    }
}
UTube.properties = {
    label: "U-Bent Tube",
    kind: "tube",
    defaultAppearance: {
        diameter: defaultDiameter,
        size: 60
    },
    appearanceSpecs: [
        TUBE_DIAMETER_SPEC,
        {
            spec: "slider", key: "size", label: "Size",
            min: 30, max: 150,
        },
    ],
};
export class STube {
    render(appearance) {
        let diameter = appearance.diameter;
        let leftAngle = appearance.angle1;
        let rightAngle = appearance.angle2;
        let semilength = 15;
        // Length of the section connecting the two end in the middle.
        let middleLength = appearance.length;
        let rightEnd = tubeBend(diameter, rightAngle, semilength, semilength);
        let leftEnd = tubeBend(diameter, leftAngle, semilength, semilength);
        // reflect the left end.
        leftEnd.topWall.scale(-1, P(0, 0));
        leftEnd.bottomWall.scale(-1, P(0, 0));
        // Shift the segments of the right end.
        rightEnd.topWall.segments.forEach((s) => s.point.x += middleLength);
        rightEnd.bottomWall.segments.forEach((s) => s.point.x += middleLength);
        // Assembe the top walls and bottom walls separately.
        let graphic = new Group([
            new Path([
                ...leftEnd.bottomWall.segments,
                ...rightEnd.topWall.segments,
            ]),
            new Path([
                ...rightEnd.bottomWall.segments,
                ...leftEnd.topWall.segments,
            ])
        ]);
        setDefaultStyle(graphic);
        // Join everything together to create the hit shape.
        let hitShape = new Path([
            ...leftEnd.bottomWall.segments,
            ...rightEnd.topWall.segments,
            ...rightEnd.bottomWall.segments,
            ...leftEnd.topWall.segments,
        ]);
        return {
            graphic: graphic,
            hitShape: hitShape,
            snapping: [
                Object.assign(Object.assign({}, rightEnd.snapping), { at: rightEnd.snapping.at.add([middleLength, 0]) }),
                Object.assign(Object.assign({}, leftEnd.snapping), { at: leftEnd.snapping.at.multiply(-1), facing: leftEnd.snapping.facing + 180 })
            ]
        };
    }
}
STube.properties = {
    label: "S-Bent Tube",
    kind: "tube",
    flippable: true,
    defaultAppearance: {
        diameter: defaultDiameter,
        angle1: 90,
        angle2: 90,
        length: 80
    },
    appearanceSpecs: [
        TUBE_DIAMETER_SPEC,
        Object.assign({ spec: "slider", key: "angle1", label: "First angle" }, bendSpecs),
        Object.assign({ spec: "slider", key: "angle2", label: "Second angle" }, bendSpecs),
        {
            spec: "slider", key: "length", label: "Length",
            min: 0, max: 120
        }
    ],
};
export class AdapterTube {
    render(appearance) {
        let radius1 = appearance.diameter1 / 2;
        let radius2 = appearance.diameter2 / 2;
        var hitShape = new Path(Segments(
        // Top
        [[-30, -radius1]], [[-15, -radius1], undefined, [5, 0]], [[15, -radius2], [-5, 0]], [[30, -radius2]], 
        // Bottom
        [[30, radius2]], [[15, radius2], undefined, [-5, 0]], [[-15, radius1], [5, 0]], [[-30, radius1]]));
        let graphic = breakPath(hitShape, 4);
        setDefaultStyle(graphic);
        return {
            graphic: graphic,
            hitShape: hitShape,
            snapping: [
                { type: "connectable", at: P(-30, 0), facing: -90 },
                { type: "connectable", at: P(30, 0), facing: 90 },
            ]
        };
    }
}
AdapterTube.properties = {
    label: "Adapter Tube",
    defaultAppearance: {
        diameter1: 8,
        diameter2: defaultDiameter,
    },
    appearanceSpecs: [
        {
            spec: "slider", min: MIN_DIAMETER, max: MAX_DIAMETER,
            key: "diameter1", label: "First diameter",
        },
        {
            spec: "slider", min: MIN_DIAMETER, max: MAX_DIAMETER,
            key: "diameter2", label: "Second diameter",
        }
    ],
};
/**
 * Helper method to draw a tube bend.
 *
 *               r     D   D2
 *                   /   /
 *           e     C   C2
 *   A ------- B /   /    e = semi length
 *   o            p /     r = rotary pivot
 *   A2 ------ B2 -/      o = origin, p = pivot
 * Parameters:
 *  - diameter: The thickness of the tube
 *  - angle: The angle the tube should bend
 *  - semilength: length from A -> B and C -> D
 * Returns:
 *  - topWall: (A,B,C,D)
 *  - bottomWall: (D2,C2,B2,A2)
 *  - snapPoint: The snappoint for the D-end. A-end is simply P(0, 0)
 */
function tubeBend(diameter, angle, semilength, onesidelength) {
    let radius = diameter / 2;
    // Length dedicated to drawing the bend.
    let tubeBendLength = diameter * 3;
    // Set up the pivot around which the tube bends
    let rotationPivotDistance = angle != 0 ? tubeBendLength / angle.toRadians() : 100;
    let r = P(semilength, rotationPivotDistance);
    // Unit direction vector that determines where to draw
    // point D from C and also the (inverse) handleIn for C.
    let directionC = P(1, 0).rotate(angle);
    // Same, but for point B, from A to B
    let directionB = P(1, 0);
    // Set up the points that define the bend. Watch out for angle = 0
    let a = P(0, -radius);
    let b = P(semilength, -radius);
    let c = angle != 0 ? b.rotate(angle, r) : b.add([tubeBendLength, 0]);
    let d = c.add(directionC.multiply(onesidelength));
    let a2 = P(0, radius);
    let b2 = P(semilength, radius);
    let c2 = angle != 0 ? b2.rotate(angle, r) : b2.add([tubeBendLength, 0]);
    let d2 = c2.add(directionC.multiply(onesidelength));
    // Factor by which to scale handle points in the bend.
    let handlesFactor = tubeBendLength * 0.4;
    let outerFactor = handlesFactor * (1 + radius / rotationPivotDistance);
    let innerFactor = handlesFactor * (1 - radius / rotationPivotDistance);
    let topHandlesFactor = outerFactor;
    let bottomHandleFactor = innerFactor;
    let topWall = new Path([
        S(a),
        S(b, undefined, directionB.multiply(topHandlesFactor)),
        S(c, directionC.multiply(-topHandlesFactor)),
        S(d)
    ]);
    // Constructed in reverse.
    let bottomWall = new Path([
        S(d2),
        S(c2, undefined, directionC.multiply(-bottomHandleFactor)),
        S(b2, directionB.multiply(bottomHandleFactor)),
        S(a2),
    ]);
    return {
        topWall: topWall,
        bottomWall: bottomWall,
        snapping: {
            type: "connectable",
            at: angle != 0
                ? P(semilength, 0).rotate(angle, r).add(directionC.multiply(onesidelength))
                : P(d.x, 0),
            facing: 90 + angle
        }
    };
}
